var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadPhotoPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84 84",
    style: {
      enableBackground: "new 0 0 84 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#26A6FE;}\r\n\t.st1{fill:#ACACAC;}\r\n\t.st2{fill:#FAC600;}\r\n\t.st3{fill:#838383;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#F8F6F6;}\r\n\t.st6{fill:#FED2A4;}\r\n\t.st7{fill:#FFBD86;}\r\n\t.st8{fill:#D8ECFE;}\r\n\t.st9{fill:#B3DAFE;}\r\n\t.st10{fill:#FB8801;}\r\n\t.st11{fill:#FE9901;}\r\n\t.st12{fill:#F6A96C;}\r\n\t.st13{fill:#D88A55;}\r\n\t.st14{fill:#E8B800;}\r\n\t.st15{fill:#22B27F;}\r\n\t.st16{fill:#09A76D;}\r\n\t.st17{fill:#8AC9FE;}\r\n\t.st18{fill:#60B7FF;}\r\n\t.st19{fill:#00BDB4;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 41.8,
    cy: 41.7,
    r: 39.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.6,23.2h1.9v3.3h-1.9V23.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.6,49.3V72c0.7-0.7,1.3-1.5,1.9-2.3V49.3H64.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.8,21.4H52.5c0.4,0.6,0.7,1.2,1,1.9h17.4c0.5,0,1-0.4,1-1C71.8,21.9,71.4,21.4,70.8,21.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M63.3,46.4v1.8c0,0.7,0.6,1.3,1.3,1.3h2c0.7,0,1.3-0.6,1.3-1.3v-1.8H63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65.3,48.2v-1.8h-2v1.8c0,0.7,0.6,1.3,1.3,1.3h2C65.9,49.4,65.3,48.9,65.3,48.2L65.3,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.5,71.4c0-0.4-0.2-0.7-0.6-0.7l-6.2-1.5v4.7c2,1.9,4.3,3.4,6.8,4.7V71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M23.4,69.8l-2.7-0.7v4.7c0.8,0.8,1.7,1.5,2.7,2.2V69.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M56.6,70.6C56.2,70.7,56,71,56,71.4v7.2c2.5-1.3,4.7-2.9,6.8-4.7v-4.7L56.6,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M58.7,70.1l-2.1,0.5C56.2,70.7,56,71,56,71.4v7.2c0.9-0.5,1.8-1,2.7-1.5V70.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66.5,67.6l-3.7-14.2c-0.8-2.7-3.3-4.6-6.1-4.6H26.8c-2.8,0-5.3,1.9-6.1,4.6L17,67.6 c-0.1,0.3,0.1,0.7,0.5,0.8l9.5,2.4c0.3,0.1,0.5,0.3,0.5,0.6v7.1c4.3,2.2,9.2,3.5,14.4,3.5s10.1-1.3,14.4-3.5v-7.1 c0-0.3,0.2-0.5,0.5-0.6l9.5-2.4C66.4,68.3,66.6,68,66.5,67.6L66.5,67.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M30.7,80v-9.4c0-0.9-0.6-1.6-1.4-1.9l-8.5-2.1c-0.3-0.1-0.6-0.4-0.5-0.8L24,51.6c0.3-1,0.8-1.9,1.5-2.6 c-2.3,0.5-4.1,2.1-4.8,4.4L17,67.6c-0.1,0.3,0.1,0.7,0.5,0.8l9.5,2.4c0.3,0.1,0.5,0.3,0.5,0.6v7.1C28.4,79,29.5,79.5,30.7,80 L30.7,80z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M47.1,18.5h-2.7c1.5,1.2,2.4,3.1,2.4,5.1v2.6h0.5c2.2,0,4,1.8,4,4v2.2h1.6c0.4,0,0.7,0.1,1,0.2v-7.2 C53.9,21.6,50.9,18.5,47.1,18.5L47.1,18.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M30.6,32.3h1.6v-2.2c0-2.2,1.8-4,4-4h10.7v-2.6c0-3.7-3-6.8-6.8-6.8h-3.7c-3.7,0-6.8,3-6.8,6.8v8.9 C29.9,32.4,30.3,32.3,30.6,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M30.6,32.3h1.6v-2.2c0-1.7,1.1-3.2,2.7-3.8v-2.8c0-3.5,2.6-6.3,6-6.7c-0.3,0-0.5,0-0.8,0h-3.7 c-3.7,0-6.8,3-6.8,6.8v8.9C29.9,32.4,30.3,32.3,30.6,32.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M32.2,39.5v-7.3h-1.5c-1.6,0-2.9,1.3-2.9,2.9v1.8c0,1.6,1.3,2.9,2.9,2.9h1.5 C32.2,39.7,32.2,39.6,32.2,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52.7,32.2h-1.5v7.3c0,0.1,0,0.2,0,0.3h1.5c1.6,0,2.9-1.3,2.9-2.9v-1.8C55.7,33.5,54.3,32.2,52.7,32.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M45.5,48.2v-1.4C45,47,44.4,47,43.8,47h-4c-0.6,0-1.2-0.1-1.8-0.2v1.4c0,0.4-0.3,0.6-0.6,0.6h-1.7l1,1.7 l5.1,7.6l5-7.6l1-1.8h-1.7C45.8,48.9,45.5,48.6,45.5,48.2L45.5,48.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M40.8,50.3h0.5c0.4,0,0.6-0.3,0.6-0.6v-2.5h-2.2c-0.6,0-1.2-0.1-1.8-0.2v1.3c0,0.4-0.3,0.6-0.6,0.6h-1.7 l1,1.7l5.1,7.6l1.5-2.3l-3.1-4.7C40,50.8,40.3,50.3,40.8,50.3L40.8,50.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.8,47.2h-4c-4.2,0-7.6-3.4-7.6-7.6v-9.3c0-2.3,1.8-4.1,4.1-4.1h11.1c2.3,0,4.1,1.8,4.1,4.1v9.3 C51.4,43.7,48,47.2,43.8,47.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M36.1,39.5v-9.3c0-2.3,1.8-4.1,4.1-4.1h-4c-2.3,0-4.1,1.8-4.1,4.1v9.3c0,4.2,3.4,7.6,7.6,7.6h4 C39.5,47.2,36.1,43.7,36.1,39.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M36.7,35.9c-0.5,0-1-0.4-1-1v-2.1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1v2.1C37.6,35.4,37.2,35.9,36.7,35.9z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M46.8,35.9c-0.5,0-1-0.4-1-1v-2.1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1v2.1C47.8,35.4,47.4,35.9,46.8,35.9z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M42.1,43.1c-1.3,0-2.6-0.5-3.6-1.5c-0.4-0.4-0.4-1,0-1.3c0.4-0.4,1-0.4,1.3,0c1.3,1.3,3.3,1.3,4.6,0 c0.4-0.4,1-0.4,1.3,0c0.4,0.4,0.4,1,0,1.3C44.7,42.6,43.4,43.1,42.1,43.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M42.8,38.1h-0.9c-0.8,0-1.4-0.6-1.4-1.4v-2.2c0-0.5,0.4-1,1-1s1,0.4,1,1v1.7h0.5c0.5,0,1,0.4,1,1 S43.3,38.1,42.8,38.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.8,48.9L41.8,58l-6.1-9.1h-1.5l10.7,15.9c0.6,0.9,1,2.1,1,3.2v13.7c0.4-0.1,0.9-0.1,1.3-0.2V68 c0-1.4-0.4-2.7-1.2-3.9l-3.3-5l6.8-10.3L47.8,48.9L47.8,48.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M70.5,46.5h-9.9c-0.7,0-1.3-0.6-1.3-1.3V27.7c0-0.7,0.6-1.3,1.3-1.3h9.9c0.7,0,1.3,0.6,1.3,1.3v17.6 C71.8,45.9,71.2,46.5,70.5,46.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M63.9,45.2v-0.6h-2c-0.4,0-0.6-0.3-0.6-0.6V32.8c0-0.4,0.3-0.6,0.6-0.6h2v-4.5c0-0.7,0.6-1.3,1.3-1.3h-4.6 c-0.7,0-1.3,0.6-1.3,1.3v17.6c0,0.7,0.6,1.3,1.3,1.3h4.6C64.5,46.5,63.9,45.9,63.9,45.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.9,35.9v-3.2c0-0.4-0.3-0.6-0.6-0.6h-7.4c-0.4,0-0.6,0.3-0.6,0.6v3.2H69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,42.1V44c0,0.4,0.3,0.6,0.6,0.6h7.4c0.4,0,0.6-0.3,0.6-0.6v-1.9H61.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M64.7,35.9v-3.2c0-0.4,0.3-0.6,0.6-0.6h-3.4c-0.4,0-0.6,0.3-0.6,0.6v3.2H64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M64.7,44v-1.9h-3.4V44c0,0.4,0.3,0.6,0.6,0.6h3.4C64.9,44.6,64.7,44.3,64.7,44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M60.4,41.8v-5.6c0-0.2,0.2-0.4,0.4-0.4h9.5c0.2,0,0.4,0.2,0.4,0.4v5.6c0,0.2-0.2,0.4-0.4,0.4h-9.5 C60.6,42.2,60.4,42,60.4,41.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M64.1,41.8v-5.6c0-0.2,0.2-0.4,0.4-0.4h-3.7c-0.2,0-0.4,0.2-0.4,0.4v5.6c0,0.2,0.2,0.4,0.4,0.4h3.7 C64.2,42.2,64.1,42,64.1,41.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M63.5,39.4v-1.1c0-0.4,0.3-0.7,0.7-0.7h2.7c0.4,0,0.7,0.3,0.7,0.7v1.1c0,0.4-0.3,0.7-0.7,0.7h-2.7 C63.8,40.1,63.5,39.8,63.5,39.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M65.3,39.4v-1.1c0-0.4,0.3-0.7,0.7-0.7h-1.8c-0.4,0-0.7,0.3-0.7,0.7v1.1c0,0.4,0.3,0.7,0.7,0.7H66 C65.6,40.1,65.3,39.8,65.3,39.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M37.8,63h-1.6c-0.1,0-0.2-0.1-0.2-0.2v-1.6c0-0.1-0.1-0.2-0.2-0.2h-1.9c-0.1,0-0.2,0.1-0.2,0.2v1.6 c0,0.1-0.1,0.2-0.2,0.2h-1.6c-0.1,0-0.2,0.1-0.2,0.2v1.9c0,0.1,0.1,0.2,0.2,0.2h1.6c0.1,0,0.2,0.1,0.2,0.2v1.6 c0,0.1,0.1,0.2,0.2,0.2h1.9c0.1,0,0.2-0.1,0.2-0.2v-1.6c0-0.1,0.1-0.2,0.2-0.2h1.6c0.1,0,0.2-0.1,0.2-0.2v-1.9 C38,63.1,37.9,63,37.8,63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M35.3,66c-0.1,0-0.2-0.1-0.2-0.2v-1.6c0-0.1-0.1-0.2-0.2-0.2h-1.6c-0.1,0-0.2-0.1-0.2-0.2V63h-1.1 c-0.1,0-0.2,0.1-0.2,0.2v1.9c0,0.1,0.1,0.2,0.2,0.2h1.6c0.1,0,0.2,0.1,0.2,0.2v1.6c0,0.1,0.1,0.2,0.2,0.2h1.9 c0.1,0,0.2-0.1,0.2-0.2V66H35.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M37.1,71h-4.5c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h4.5c0.5,0,1,0.4,1,1C38.1,70.6,37.6,71,37.1,71z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M34.3,70c0-0.5,0.4-1,1-1h-2.5c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1h2.5C34.7,71,34.3,70.6,34.3,70z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 64.3,
    cy: 64.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 56.5,
    className: "st4",
    width: 1.7,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 56.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 128.8417 0.1586)",
    className: "st4",
    width: 1.7,
    height: 16
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhotoPatient);
export default __webpack_public_path__ + "static/media/Upload-Photo-patient.9b79c167454296343de86a3896f27026.svg";
export { ForwardRef as ReactComponent };